import Link from 'next/link'
import React from 'react'

import { useGetKeyPairValue, MILKvKeys } from 'api/microlearning/useAPIKeyValue'

const RKMMBanner = () => {
  const contributionBanner = useGetKeyPairValue(
    MILKvKeys.RKMMContributionBanner
  )
  return (
    <>
      {contributionBanner.isSuccess &&
        contributionBanner.data?.data?.link &&
        contributionBanner.data?.data?.image && (
          <div className="px-3">
            <Link href={contributionBanner.data.data.link} className="block">
              <img
                src={contributionBanner.data.data.image}
                alt="Banner program kontribusi perangkat ajar"
                className="w-full mx-auto max-w-[428px] h-auto"
              />
            </Link>
          </div>
        )}
    </>
  )
}

export default RKMMBanner
